import React from 'react'
import { Footer, Navbar } from "../components";
const AboutPage = () => {
  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">About Us</h1>
        <hr />
        <p className="lead text-center">
        Seoulveda represents the harmonious blend of Korean skincare wisdom and Indian heritage. Dedicated to the art of self-care, 
        the brand offers thoughtfully curated skincare solutions inspired by Korea's advanced formulations and 
        India’s rich traditions in holistic well-being.
        
        Our products embody the essence of both cultures—combining natural, effective ingredients with modern dermatological innovation.
         With a commitment to transparency and efficacy, Seoulveda empowers consumers to make informed decisions about their skin health.

         Our proprietary AI-powered app serves as an educational companion, providing personalized skincare insights,
          real-time monitoring, and tailored recommendations. By fostering trust through technology,
           we aim to create a community that values self-care as a journey.
        </p>

        <h2 className="text-center py-4">Our Products</h2>
        <div className="row">
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://th.bing.com/th?id=OIP.kcqdTunbVYpEiEhd0f1FlQHaGK&w=273&h=228&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Makeup</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://th.bing.com/th/id/OIP.adzAUo292jPeIFrgaVuF1AHaE8?w=274&h=183&c=7&r=0&o=5&dpr=1.3&pid=1.7" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Skincare</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://th.bing.com/th/id/OIP.MzTzW4u4ByZEuSAiYAvLRgHaE8?w=271&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Haircare</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default AboutPage